module.exports = "https://cdn.littlereply.com/tt/resource/feed_lucky_coins.4d4032a6d6a252dd63dd6ce3d4816fb7.png";